<template>
  <v-btn icon @click="toggleBookmark" :title="title">
    <v-icon>{{ currentIcon }}</v-icon>
  </v-btn>
</template>

<script>
import BoltBookmarks from './BoltBookmarks'

export default {
  // props: {
  // label: {  },
  // to: {  }
  // icon: {}
  // },
  computed: {
    to() {
      return this.$route.path
    },
    title() {
      if (this.hasBookmark) return 'Remover dos favoritos'
      else return 'Adicionar aos favoritos'
    },
    hasBookmark() {
      return BoltBookmarks.items.some((x) => x.to == this.to)
    },
    currentIcon() {
      return this.hasBookmark ? 'mdi-star' : 'mdi-star-outline'
    }
  },
  methods: {
    toggleBookmark() {
      if (this.hasBookmark) {
        BoltBookmarks.removeBookmark(this.to)
        this.$snack('Removido dos favoritos')
      } else {
        let label = document.title
        BoltBookmarks.addBookmark(label, this.to)
        this.$snack('Adicionado aos favoritos')
      }
    }
  }
}
</script>

<style></style>
